const state = {
  i18next: require('../../../../isrs_consumer_app/i18next.json'),
  i18nextMail: {
    en: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    de: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    pl: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    da: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    nl: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    nl_be: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    fr: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    fr_be: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    },
    hu: {
      translation: {
        subject: 'Example Subject',
        text: `Example Text. \n\n> You can use Markdown. `
      }
    }
  },
  accordionKeys: [
    'returnReason',
    'return',
    'hero',
    'headline',
    'form',
    'psf',
    'nav',
    'print_qr',
    'confirm',
    'btn',
    'summary',
    'successscreen',
    'browsernotice'
  ]
}

const getters = {}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/texts.js